import DialogContent from "@material-ui/core/DialogContent";
export default DialogContent;